module.exports = __webpack_public_path__ + "static/Menu-1abe68bc155ebad961f63ad000f534fe.png";